module.exports = __webpack_public_path__ + "img/domidep.dfdf83eb.png";